// EmailSettings only. Shared table methods are in tableMixin.js.
export default {
    name: "EmailSettings",
    methods: {
        clearForm() {
            this.isEditing = false;
            this.isSaving = false;
            this.submitted = false;
            this.formInputs = this.getDefaultFormInputs(); // provider, host and port too
            this.customPlaceholders = { from_host: "", from_port: "", from_smtp_secure: "" };
            this.$clearValidationStates("#recordForm");
        },
        // Provider picked in the box (not when Edit or Sample fill the form)
        onProviderChange(provider) {
            this.$clearValidationAlert("#recordForm");

            const custom = provider === "Custom Email";
            this.customPlaceholders.from_host = custom ? "e.g., smtp.yourdomain.com" : "";
            this.customPlaceholders.from_port = custom ? "e.g., 587" : "";
            this.customPlaceholders.from_smtp_secure = custom ? "Choose tls or ssl" : "";

            this.autoFillEmailSettingsByProvider(provider);
        },
        // Provider chosen: fill in the host, port and SSL/TLS for it
        autoFillEmailSettingsByProvider(provider) {
            const providerSettings = {
                "Gmail": {
                    from_host: "smtp.gmail.com",
                    from_port: "587",
                    from_smtp_secure: "tls",
                },
                "Outlook": {
                    from_host: "smtp.office365.com",
                    from_port: "587",
                    from_smtp_secure: "tls",
                },
                "Yahoo": {
                    from_host: "smtp.mail.yahoo.com",
                    from_port: "587",
                    from_smtp_secure: "tls",
                },
                "iCloud": {
                    from_host: "smtp.mail.me.com",
                    from_port: "587",
                    from_smtp_secure: "tls",
                },
                "Proton": {
                    from_host: "127.0.0.1",
                    from_port: "1025",
                    from_smtp_secure: "tls",
                },
                "Zoho": {
                    from_host: "smtp.zoho.com",
                    from_port: "587",
                    from_smtp_secure: "tls",
                },
                "GMX": {
                    from_host: "mail.gmx.com",
                    from_port: "587",
                    from_smtp_secure: "tls",
                },
                "Yandex": {
                    from_host: "smtp.yandex.com",
                    from_port: "465",
                    from_smtp_secure: "ssl",
                },
                "Mail.com": {
                    from_host: "smtp.mail.com",
                    from_port: "587",
                    from_smtp_secure: "tls",
                },
                "Tutanota": {},
                "Custom Email": {},
            };

            const settings = providerSettings[provider] || {};

            // Only the server details change: the email, password and name you typed stay
            this.formInputs.from_host = settings.from_host || "";
            this.formInputs.from_port = settings.from_port || "";
            this.formInputs.from_smtp_secure = settings.from_smtp_secure || "";
        },
    },
};